<template>
  <div :class="{ 'is-invalid': state !== null && !state }">
    <b-input-group>
      <template #prepend>
        <b-dropdown :text="fragment1" :variant="state === null || state ? 'info' : 'danger'">
          <b-dropdown-item v-for="(option, idx) in optionsFragment1" :key="idx" @click="selectFragment1(option)">{{ option }}</b-dropdown-item>
        </b-dropdown>
      </template>
      <b-form-input v-model="fragment2" :state="state"></b-form-input>
      <b-dropdown :text="separator1" :variant="state === null || state ? 'info' : 'danger'">
        <b-dropdown-item v-for="(option, idx) in optionsSeparator1" :key="idx" @click="selectSeparator1(option)">{{ option }}</b-dropdown-item>
      </b-dropdown>
      <b-form-input v-model="fragment3" :state="state" maxlength="128"></b-form-input>
      <template v-if="separator1 === '#'">
        <b-input-group-text>-</b-input-group-text>
        <b-form-input v-model="fragment4" :state="state" maxlength="128"></b-form-input>
      </template>
      <!--
      <template #append>
        <b-dropdown :text="fragment5" :variant="state === null || state ? 'info' : 'danger'">
          <b-dropdown-item v-for="(option, idx) in optionsFragment5" :key="idx" @click="selectFragment5(option)">{{ option }}</b-dropdown-item>
        </b-dropdown>
      </template>
      -->
    </b-input-group>
    <b-form-input v-model="fragment6" :state="state" placeholder="Información adicional (casa, conjunto residencial, etc.)" maxlength="128"></b-form-input>
  </div>
</template>

<script lang="ts">
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import {add} from 'store2'
@Component
export default class NRC extends Vue {
  @Prop() value: string
  @Prop() state: boolean

  fragment1: string = 'Calle'
  fragment2: string = ''
  fragment3: string = ''
  fragment4: string = ''
  fragment5: string = 'Norte'
  fragment6: string = ''
  separator1: string = '#'

  get optionsFragment1(): Array<string> {
    return [
      'Calle',
      'Diagonal',
      'Carrera',
      'Transversal',
      'Avenida',
      'Avenida carrera',
      'Avenida calle',
      'Circunvalar',
      'Vía',
      'Manzana',
      'Urbanización',
      'Conjunto residencial',
      'Vereda',
    ]
  }

  get optionsFragment5(): Array<string> {
    return ['Norte', 'Sur']
  }

  get optionsSeparator1(): Array<string> {
    return ['#', 'Casa', 'Apartamento', 'Lote', 'Km']
  }

  get address(): any {
    this.fragment1
    this.fragment2
    this.fragment3
    this.fragment4
    //this.fragment5
    this.fragment6
    this.separator1
    return Date.now()
  }

  selectFragment1(fragment): void {
    this.fragment1 = fragment
  }

  selectFragment5(fragment): void {
    this.fragment5 = fragment
  }

  selectSeparator1(separador): void {
    this.separator1 = separador
  }

  @Watch('address')
  addressChange(newValue, oldValue) {
    if (newValue != oldValue) {
      if (this.separator1 !== '#') {
        this.fragment4 = ''
      }
      this._buildAddress()
    }
  }

  _buildAddress(): void {
    if (this.fragment1 && this.fragment2 && this.separator1 && this.fragment3) {
      let address = `${this.fragment1.replaceAll(
        '/',
        ''
      )}/${this.fragment2.replaceAll('/', '')}/${this.separator1.replaceAll(
        '/',
        ''
      )}/${this.fragment3.replaceAll('/', '')}`
      address += `/${this.fragment4.replaceAll('/', '')}`
      //  address += `|${this.fragment5.replace('/','')}`
      address += `/|${this.fragment6.replaceAll('/', '').replaceAll('|', '')}`
      this.$emit('input', address.trim())
    }
  }

  created() {
    let value = this.value
    let fragment6: string
    if (value) {
      ;[
        this.fragment1,
        this.fragment2,
        this.separator1,
        this.fragment3,
        this.fragment4,
        fragment6,
      ] = value?.split('/')
      this.fragment6 = fragment6?.replaceAll('|', '')
    }
  }
}
</script>
